import React from "react";
import { Link } from "react-router-dom";
import logo from '../components/images/vigyan-vriksh-logo.png';

const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
        <img src={logo} alt="" style={{width : "30%"}} />
      <h1 className="display-3 fw-bold text-danger">404</h1>
      <h2 className="mb-3">Page Not Found</h2>
      <p className="text-muted mb-4">
        Oops! The page you are looking for does not exist.
      </p>
      <Link to="/" className="btn btn-danger px-4">
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
